// src/components/utils/ptComponents.jsx

import React from 'react';
// NO NEED to import urlFor

export const ptComponents = {
  // --- LISTS --- (Keep these as they fix bullet points)
  list: {
    bullet: ({ children }) => <ul className="list-disc list-inside space-y-2 my-4 pl-4">{children}</ul>,
    number: ({ children }) => <ol className="list-decimal list-inside space-y-2 my-4 pl-4">{children}</ol>,
  },
  listItem: {
    bullet: ({ children }) => <li className="leading-relaxed">{children}</li>,
    number: ({ children }) => <li className="leading-relaxed">{children}</li>,
  },

  // --- BLOCK TYPES --- (Keep these)
  block: {
    h1: ({ children }) => <h1 className="text-3xl md:text-4xl font-bold mt-8 mb-4">{children}</h1>,
    h2: ({ children }) => <h2 className="text-2xl md:text-3xl font-semibold mt-6 mb-3">{children}</h2>,
    h3: ({ children }) => <h3 className="text-xl md:text-2xl font-semibold mt-5 mb-2">{children}</h3>,
    h4: ({ children }) => <h4 className="text-lg md:text-xl font-semibold mt-4 mb-1">{children}</h4>,
    blockquote: ({ children }) => <blockquote className="border-l-4 border-prime-300 pl-4 italic my-6 text-gray-700">{children}</blockquote>,
    normal: ({ children }) => <p className="leading-relaxed my-4">{children}</p>,
  },

  // --- MARKS --- (Keep these)
  marks: {
    strong: ({ children }) => <strong>{children}</strong>,
    em: ({ children }) => <em>{children}</em>,
    underline: ({ children }) => <span className="underline">{children}</span>,
    'strike-through': ({children}) => <del>{children}</del>,
    link: ({ children, value }) => <a>{children}</a>
    // internalLink: ({value, children}) => { /* ... if needed ... */ }
  },

  // --- CUSTOM TYPES (Image) ---
  types: {
    image: ({ value }) => {
       // Check for the DIRECT URL fetched in the query
       if (!value?.url) {
         console.warn("Portable Text Image block missing URL:", value);
         // Optional: Render a placeholder if URL is missing
         return (
            <div className="my-8 flex justify-center items-center bg-gray-200 aspect-video rounded-lg">
                <span className="text-gray-500 text-sm">Bild nicht verfügbar</span>
            </div>
         );
       }
       // Render using the direct URL
       return (
         <figure className="my-8">
           <img
             src={value.url} // Use the direct URL
             alt={value.alt || 'Blog post image'}
             loading="lazy"
             className="max-w-full h-auto mx-auto rounded-lg shadow-md"
           />
           {value.caption && (
             <figcaption className="text-center text-sm text-gray-600 mt-3 italic">
               {value.caption}
             </figcaption>
           )}
         </figure>
       );
    },
     // Add renderers for other custom types like 'quote' if you have them
  },
};